import { render } from "./base-coach-mark.vue?vue&type=template&id=103addf8&ts=true"
import script from "./base-coach-mark.vue?vue&type=script&lang=ts"
export * from "./base-coach-mark.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__